var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "5%", height: "95%" },
          attrs: {
            title: _vm.title,
            width: 800,
            visible: _vm.visible,
            confirmLoading: _vm.confirmLoading,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            wrapClassName: _vm.wrapClassNameInfo(),
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "取消",
            okText: "保存",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.confirmLoading } },
            [
              _c("a-table", {
                ref: "table",
                attrs: {
                  size: "small",
                  rowKey: "id",
                  columns: _vm.columns,
                  dataSource: _vm.dataSource,
                  pagination: false,
                  customRow: null,
                  loading: _vm.loading,
                  rowSelection: {
                    selectedRowKeys: _vm.selectedRowKeys,
                    onChange: _vm.onSelectChange,
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }